import styled from 'styled-components';

export const Container = styled.div`
  margin-top: ${props => props.theme.spacing(4)};
  background-color: ${props => props.theme.colors.background.lightest};
  border-radius: ${props => props.theme.spacing(8)};
  padding: ${props => props.theme.spacing(0, 6, 6, 6)};
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${props => props.theme.tablet} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
  }
`;

export const Content = styled.div`
  @media ${props => props.theme.tablet} {
    margin: ${props => props.theme.spacing(0, 0, 0, 8)};
  }
`;

export const HeroTitle = styled.h4`
  ${props => props.theme.typography.subheading1}
  color: ${props => props.theme.colors.hero.blueberry};
  text-transform: uppercase;
`;

export const BodyText = styled.p`
  margin: ${props => props.theme.spacing(4, 0)};
  ${props => props.theme.typography.body}

  @media ${props => props.theme.tablet} {
    ${props => props.theme.typography.heading4}
  }
`;

// Used to extend border-bottom to 100% of parent size
export const ImageContainer = styled.div`
  width: 100%;
  margin-bottom: ${props => props.theme.spacing(6)};
  border-bottom: 1px solid ${props => props.theme.colors.background.disabled};
  order: 0;

  @media ${props => props.theme.tablet} {
    order: 2;
    flex: 0;
    margin-bottom: 0;
    border-bottom: none;
  }
`;

// Used to set image size and maintain aspect ratio.
export const ImageWrapper = styled.div`
  position: relative;
  margin: auto;
  width: 100%;
  aspect-ratio: 1 / 0.83;

  @media ${props => props.theme.tablet} {
    width: 349px;
  }
`;

export const ButtonContainer = styled.div`
  max-width: ${props => props.theme.spacing(70)};
`;
